"use client"

import { observer } from "mobx-react-lite"
import { useEffect, useState } from "react"
import { useAppContext } from "../../shared/functions/Context"
import { LoadingEllipsis } from "../../shared/components/loading/Loading"
import ErrorBoundary from "../../shared/components/error-boundary/ErrorBoundary"

import PersonalDevelopmentDashboard from "./dashboard/PersonalDevelopmentDashboard"
import PersonalDevelopmentProfile from "./profile/PersonalDevelopmementProfile"
import { CalenderView } from "./calender/CalenderView"
import MyTrainingRequests from "./trainings/Trainings"
import Budget from "./budget/Budget"
import Reports from "./Reports/Reports"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../dashboard/company-dashboard/ui/tabs"

const PersonalDevelopmentHome = observer(() => {
  const { api, store, ui } = useAppContext()
  const scorecard = store.scorecard.activeId
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const loadAll = async () => {
      if (!scorecard) return

      setLoading(true)
      try {
        await Promise.all([
          api.user.getAll(),
          api.department.getAll(),
          api.companyMeasure.getAll(scorecard),
          api.companyObjective.getAll(scorecard),
        ])
      } catch (error) {
        ui.snackbar.load({
          id: Date.now(),
          type: "danger",
          message: "Failed to load.",
          timeoutInMs: 10000,
        })
      }
      setLoading(false)
    }

    loadAll()
  }, [api, scorecard, ui.snackbar])

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50">
        <div className="container mx-auto px-4 py-8 max-w-7xl">
          <ErrorBoundary>
            {loading ? (
              <LoadingEllipsis />
            ) : (
              <Tabs defaultValue="dashboard" className="w-full">
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-2 mb-8">
                  <TabsList className="grid w-full grid-cols-6 bg-gray-50">
                    <TabsTrigger
                      value="dashboard"
                      className="data-[state=active]:bg-[#84cbe9] data-[state=active]:text-white"
                    >
                      Dashboard
                    </TabsTrigger>
                    <TabsTrigger
                      value="profile"
                      className="data-[state=active]:bg-[#84cbe9] data-[state=active]:text-white"
                    >
                      Profile
                    </TabsTrigger>
                    <TabsTrigger
                      value="calendar"
                      className="data-[state=active]:bg-[#84cbe9] data-[state=active]:text-white"
                    >
                      Calendar
                    </TabsTrigger>
                    <TabsTrigger
                      value="trainings"
                      className="data-[state=active]:bg-[#84cbe9] data-[state=active]:text-white"
                    >
                      Trainings
                    </TabsTrigger>
                    <TabsTrigger
                      value="budget"
                      className="data-[state=active]:bg-[#84cbe9] data-[state=active]:text-white"
                    >
                      Budget
                    </TabsTrigger>
                    <TabsTrigger
                      value="reports"
                      className="data-[state=active]:bg-[#84cbe9] data-[state=active]:text-white"
                    >
                      Reports
                    </TabsTrigger>
                  </TabsList>
                </div>

                <TabsContent value="dashboard">
                  <PersonalDevelopmentDashboard />
                </TabsContent>
                <TabsContent value="profile">
                  <PersonalDevelopmentProfile />
                </TabsContent>
                <TabsContent value="calendar">
                  <CalenderView />
                </TabsContent>
                <TabsContent value="trainings">
                  <MyTrainingRequests />
                </TabsContent>
                <TabsContent value="budget">
                  <Budget />
                </TabsContent>
                <TabsContent value="reports">
                  <Reports />
                </TabsContent>
              </Tabs>
            )}
          </ErrorBoundary>
        </div>
      </div>
    </ErrorBoundary>
  )
})

export default PersonalDevelopmentHome
